<template>
    <div>
        <div class="search-container primary mb10 mt10">
            <div class="form-box">
                <input class="input-field" v-model="name" placeholder="请输资质类型名称"/>
                <button class="search-btn" @click="getStaffQualiTypeList()"><i class="icon iconfont icon-search"></i></button>
            </div>
        </div>
        <div class="table-layout">
            <el-table :height="500+'px'"  ref="staffQualiTypeTable" :data="staffQualiTypeList" border tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange" @current-change="handleCurrentChange">
                <el-table-column v-if="!isRedio" align="center" type="selection" :selectable="selectable" width="55"></el-table-column>
                <el-table-column v-if="isRedio" width="55" align="center">
                    <template slot-scope="rows">
                        <div class="copy-radio" :class="{'circle' : checkedId == rows.row.id}">
                            <div class="circle-dot"></div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="资质类型名称" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column prop="levels" label="分级数量" align="center" width="80">
                    <template slot-scope="rows">
                        <span v-if="rows.row.levels == 1">一级</span>
                        <span v-if="rows.row.levels == 2">二级</span>
                        <span v-if="rows.row.levels == 3">三级</span>
                        <span v-if="rows.row.levels == 4">四级</span>
                        <span v-if="rows.row.levels == 5">五级</span>
                    </template>
                </el-table-column>
                <!--
                <el-table-column prop="verifiable" label="是否可认证" align="center" width="100">
                    <template slot-scope="rows">
                        <span v-if="rows.row.verifiable">可认证</span>
                        <span v-if="!rows.row.verifiable">不可认证</span>
                    </template>
                </el-table-column>
                <el-table-column prop="verifyUrl" label="认证网址" align="left" width="200" show-overflow-tooltip></el-table-column>
                -->
                <el-table-column prop="forRetailer" label="适用商户" align="left" width="220">
                    <template slot-scope="rows">
                        <span v-if="rows.row.forRetailer">零售商</span>
                        <span v-if="rows.row.forVendor">供应商</span>
                        <span v-if="rows.row.forServicer">服务商</span>
                        <span v-if="rows.row.forEngineer">工程师</span>
                    </template>
                </el-table-column>
                <el-table-column prop="levels" label="选择等级（及以上）" align="center" width="260" v-if="showLevels">
                    <template slot-scope="rows">
                        <el-select placeholder="请选择" v-model="rows.row.selectLevel" :disabled='!isRedio && (selectable(rows.row) ? false: true)'>
                            <el-option v-for="level in rows.row.levelList" :label="level.name" :value="level.value"></el-option>
                        </el-select>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div class="block pagination-layout">
            <el-pagination background class="mt10" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="total, sizes, prev, pager, next, jumper"></el-pagination>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'

    import merchtComnApi from '../../api/merchtComn'

    export default {
        name: 'swb-staff-quali-type-select',
        desc: '人员资质类型-选择',
        props: {
            selectList: {
                default: null
            },
            isRedio: {
                type: Boolean,
                default: false
            },
            showLevels: {
                type: Boolean,
                default: false
            },
            forMercht: {
                type: String,
                default: null
            },
            forRetailer: {
                type: Boolean,
                default: null
            },
            forVendor: {
                type: Boolean,
                default: null
            },
            forServicer: {
                type: Boolean,
                default: null
            },
            forEngineer: {
                type: Boolean,
                default: null
            }
        },
        data: function () {
            return {
                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //
                staffQualiTypeList: [],
                name: null,
                //复选信息
                checkedIdsX: [],
                checkedIdMap: {},
                checkedDelay: 100,
                checkedIniting: false,
                checkedTblRefId: 'multipleTable',
                checkedList: [],
                // 单选
                checkedObj: null,
                checkedId: null
            }
        },
        created: function () {
            //保持pageSize的一致性
            this.pageSize = this.pageSizes.first();
            //
            this.getStaffQualiTypeList();
            //
            if(this.isRedio && this.selectList != null && this.selectList.length > 0) {
                this.checkedId = this.selectList[0].id;
                console.log(this.checkedId);
            }
        },
        methods: {
// ===================== 分页多选开始 ==============================
            addCheckId: function (id, val) {
                if(!this.checkedIdsX.contains(id)) {
                    this.checkedIdsX.add(id);
                    this.checkedList.add(val);
                    return id;
                }
                return null;
            },
            delCheckId: function (id) {
                let self = this;
                if(self.checkedIdsX.contains(id)) {
                    for(let i = 0; i < self.checkedList.length; i++) {
                        let checkedMku = self.checkedList[i];
                        if(checkedMku.id == id) {
                            self.checkedList.splice(i, 1);
                        }
                    }
                    self.checkedIdsX.remove(id);
                    return id;
                }
                return null;
            },
            handleCurrentChange: function (val) {
                if(!Utils.isNoB(val)) {
                    this.checkedId = val.id;
                }
            },
            handleSelectionChange: function (selRows) {
                let self = this;
                if(self.checkedIniting) {
                    return;
                }
                let allIds = self.staffQualiTypeList.pluck("id");
                let selIds = selRows.pluck("id");
                selIds.forEach(function (id, index) {
                    self.addCheckId(id, selRows[index]);
                });

                let lesIds = Utils.compareArrays(selIds, allIds)["less"];
                lesIds.forEach(function (id, index) {
                    self.delCheckId(id);
                });
            },
            restoreSelRows(dataRows, tblRefId, idProp){
                let self = this;
                self.checkedIniting = true;
                idProp = idProp || "id";
                let allIds = dataRows.pluck(idProp);
                let selIds = Utils.compareArrays(allIds, this.checkedIdsX)["same"];
                selIds.forEach(function (id) {
                    self.toggleListRowById(dataRows, tblRefId, idProp, id);
                });
                //
                self.checkedIniting = false
            },

            hashCheckedId(id){
                return this.checkedIdsX.contains(id);
            },

            toggleListRowById(dataRows, tblRefId, idProp, idVal){
                let self = this;
                //
                idProp = idProp || "id";
                let refTbl = self.$refs[tblRefId];
                let theRow = dataRows.find(function (row, idx) {
                    return row[idProp] == idVal;
                });
                if(theRow != null) {
                    refTbl.toggleRowSelection(theRow);
                }
            },
            // ===================== 分页多选结束 ==============================
            //===========回显禁用===============
            selectable: function (row, index) {
                let self = this;
                let checkedIds = null;
                let selectList = self.selectList;
                if(selectList != null && selectList.length > 0) {
                    checkedIds = selectList.pluck('id');
                } else {
                    checkedIds = [];
                }
                if(checkedIds.indexOf(row.id) >= 0) {
                    return false;
                } else {
                    return true;
                }
            },
            //===========回显禁用结束===============
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getStaffQualiTypeList();
            },
            getStaffQualiTypeList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                let filterItems = {};
                filterItems.includeLevels = true;
                let forMercht = self.forMercht;
                if(!Utils.isNoB(forMercht)) {
                    if(forMercht == 'forRetailer') {
                        filterItems.forRetailer = true;
                    } else if(forMercht == 'forVendor') {
                        filterItems.forVendor = true;
                    } else if(forMercht == 'forServicer') {
                        filterItems.forServicer = true;
                    } else if(forMercht == 'forEngineer') {
                        filterItems.forEngineer = true;
                    } else if(forMercht == 'forCallbid') {  // 暂用于 招投标...
                        filterItems.forCallbid = true;
                    }
                }
                if(!Utils.isNoB(self.name)) {
                    filterItems.name = self.name;
                }
                postData.filterItems = filterItems;
                let theLoad = MsgBox.loading();
                merchtComnApi.getStaffQualiTypesByFilter(postData, function (result) {
                    theLoad.close();
                    if(result.type === "info") {
                        let rows = result.data.rows;
                        // selectLevel
                        let selectList = self.selectList;
                        if(selectList != null && selectList.length > 0) {
                            rows.forEach(function (row) {
                                let isInit = true;
                                selectList.forEach(function (checked) {
                                    if(row.id == checked.id) {
                                        row.selectLevel = checked.selectLevel;
                                        isInit = false;
                                    }
                                });
                                if(isInit) {    // 回显后 未选择的设置默认值
                                    row.selectLevel = 1;
                                }
                            });
                        } else {
                            rows.forEach(function (row) {
                                row.selectLevel = 1;
                            });
                        }
                        self.staffQualiTypeList = rows;
                        //
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getDlgResult: function () {
                let self = this;
                let result = {};
                //
                if(self.isRedio) {
                    let checkedId = self.checkedId;
                    if(!Utils.isNoB(checkedId)) {
                        let staffQualiTypeList = self.staffQualiTypeList;
                        staffQualiTypeList.forEach(function (staffQualiType) {
                            if(checkedId == staffQualiType.id) {
                                self.checkedObj = staffQualiType;
                                let levelList = staffQualiType.levelList;
                                self.checkedObj.levelList = levelList;
                                levelList.forEach(function (level) {
                                    if(level.value == staffQualiType.selectLevel) {
                                        self.checkedObj.checkLevel = level;
                                    }
                                });
                            }
                        });

                        result.type = 'info';
                        result.data = self.checkedObj;
                    } else {
                        result.type = 'warn';
                        result.message = '至少选择一个类型';
                    }
                } else {
                    let multipleSelection = self.checkedList;
                    if(multipleSelection != null && multipleSelection.length > 0) {
                        multipleSelection.forEach(function (select) {
                            let levelList = select.levelList;
                            select.levelList = levelList;
                            levelList.forEach(function (level) {
                                if(level.value == select.selectLevel) {
                                    select.checkLevel = level;
                                }
                            });
                        });
                        result.type = 'info';
                        result.data = multipleSelection;
                    } else {
                        result.type = 'warn';
                        result.message = '至少选择一个类型';
                    }
                }

                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/quali/StaffQualiTypeSelect.vue